class PusherService extends BaseService
	@register()
	@inject 'PusherRepository',
		'CredentialsManager'
		'PUSHER_KEY'
		'PUSHER_CLUSTER'

	initialize: ->
		# @see App\Constant\Value\PusherConstant::BACKOFFICE_DEVICE_ID
		@userId = '__wbo_backoffice'

	getClient: (shopId = null) ->
		payload =
			device_id: @userId

		# PusherJS sends NULL values as string "null"
		if shopId?
			payload.shop_id = shopId

		return new Pusher(
			@PUSHER_KEY,
			{
				cluster: @PUSHER_CLUSTER
				channelAuthorization:
					endpoint: @PusherRepository.getAuthUrl()
					params: payload
					headersProvider: =>
						return {
							Authorization: "Bearer #{@CredentialsManager.getAccessToken()}"
						}
			}
		)

	subscribeToPresence: (shopId = null, callback = null) ->
		return @PusherRepository
			.listChannels shopId
			.then (channels) =>
				channelName = channels[shopId ? '-1']

				client = @getClient(shopId)

				channel = client.subscribe(channelName)

				if callback?
					for event in ['pusher:subscription_succeeded', 'pusher:member_added', 'pusher:member_removed']
						channel.bind event, (data) =>
							callback(channel, data, event)

				return client
